(function (Drupal) {
  Drupal.behaviors.halifaxEmailConfirm = {
    attach(context, settings) {
      const labels = document.querySelectorAll('label');

      labels.forEach((label) => {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'class'
            ) {
              if (
                label.classList.contains('js-form-required') &&
                label.classList.contains('form-required')
              ) {
                const labelFor = label.getAttribute('for');
                if (labelFor) {
                  const input = document.getElementById(labelFor);
                  if (input && input.type === 'email') {
                    input.required = 'required';
                  }
                }
              }
            }
          });
        });

        observer.observe(label, {
          attributes: true,
          attributeFilter: ['class'],
        });
      });
    },
  };
})(Drupal);
